module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "att"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_v",
      "title": "v"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fmeps"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_att",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("BOUT THE")]), _vm._v(" T"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("YPE")])])]), _vm._v(" "), _c('p', {
    staticClass: "txno"
  }), _vm._v(" "), _c('p', {
    staticClass: "txno"
  }, [_vm._v("The text is set in "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Garamond")]), _vm._v(", a typeface based on the designs of sixteenth-century French designer Claude Garamond. It has become one of the most popular choices for print, used in everything from novels to textbooks to Field Books. Its crisp lines and even weight make it ideal for reading under the covers by flashlight.")]), _vm._v(" "), _c('p', {
    staticClass: "txno"
  }), _vm._v(" "), _c('p', {
    staticClass: "txno"
  }, [_vm._v("The cover and chapter headings are set in "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Cheddar Gothic")]), _vm._v(". Hand drawn by designer Adam Ladd in 2016, the typeface consists of only uppercase characters—but all twenty-six letters offer variants with extra flourishes. Cheddar Gothic was chosen for its distinctive look and adventurous spirit.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef7e755e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abouthetype.vue
// module id = 66
// module chunks = 0